/**
 * Accepts either shape an options list comes in — plain strings or
 * `{ value, label }` objects — and returns `{ value, label }` objects.
 *
 * The select-option constants shared with the LOS are plain string arrays
 * (their values ARE the stored values), while this project's Rff* fields render
 * `{ value, label }`. Normalizing at the field boundary lets both live together
 * without maintaining two copies of every list.
 */
export const normalizeOptions = (options = []) =>
  (options || []).map((option) =>
    option !== null && typeof option === "object"
      ? option
      : { value: option, label: option },
  );

export default normalizeOptions;
